export const DEFAULT_AVIA_TAG_FILTERS = "DEF_FILTERS"
